import { useQuery } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { getSurveyById } from '../Services/Surveys.service';

/**
 * One survey, with the questionnaire of the version under edit and every language.
 *
 * Idle until there is an id — the builder also serves `/surveys/new`.
 */
export const useSurvey = (id?: string) =>
  useQuery({
    queryKey: surveysQueryKeys.detail(id ?? ''),
    queryFn: () => getSurveyById(id ?? ''),
    enabled: Boolean(id),
  });
